/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/
document.addEventListener("DOMContentLoaded", function() {
    const toggleHeading = document.getElementById("toggle-heading");
    const descriptionText = document.getElementById("description-text");

    if (toggleHeading) {
     toggleHeading.addEventListener("click", function() {
        if (descriptionText.classList.contains("visible")) {
            // Hide the description
            descriptionText.classList.remove("visible");
        } else {
            // Show the description
            descriptionText.classList.add("visible");
        }
      }); 
    }

    let windowWidth = window.innerWidth;
    if (windowWidth < 767) {
      const mobileMenuLinks = document.querySelectorAll(".navigation__links li");
      mobileMenuLinks.forEach(element => {
        element.classList.remove("align-menu-left");
        element.classList.remove("align-menu-right");
      });
    }
});

